import { useState, useEffect } from 'react';
import { get } from 'aws-amplify/api';  
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid';  
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress'; 
import Typography from '@mui/material/Typography'; 
import DownloadIcon from '@mui/icons-material/Download';
import * as endpoints from '../../endpoints.js'; 

function CustomToolbar() {
  return (
    <GridToolbarContainer> 
      <GridToolbarFilterButton /> 
      <Box sx={{ flexGrow: 1 }} /> 
    </GridToolbarContainer>
  );
}  

export default function ViewAllUrgentTaskingTable(props) {  
    const [rows, setRows] = useState([]);  
    const [loading, setLoading] = useState(true);  
    
    useEffect(() => {   
      const getData = async () => {
        try {
          const getOperation = get({ 
          apiName: 'gccadhoctaskingapi',
          path: '/gccadhoctasking' 
          });
          const { body } = await getOperation.response;
          const json = await body.json();
          const temp = [];  
          json.forEach(x => {
            if (x.delete) {
                return; // Skip item
            } else {  
              if (x.taskingStatus === "completed") { 
                if (x.errorMessage) { 
                  temp.push(    
                    {
                      id: x.PK,
                      platform: x.application,
                      page_name: x.pageName,
                      page_url: x.pageUrl,
                      page_username: x.pageSelectorUsername,
                      page_id: x.pageSelectorAccountId,
                      creator: x.user,
                      tasking_status: x.errorMessage,
                      date_created_epoch: x.date_created_epoch
                    }
                  ) 
                } else {
                  temp.push(    
                    {
                      id: x.PK,
                      platform: x.application,
                      page_name: x.pageName,
                      page_url: x.pageUrl,
                      page_username: x.pageSelectorUsername,
                      page_id: x.pageSelectorAccountId,
                      creator: x.user,
                      tasking_status: x.s3FileUri, // contains spoc-adhoc-bucket
                      date_created_epoch: x.date_created_epoch
                    }
                  )   
                } 
              } else { 
                temp.push(    
                  {
                    id: x.PK,
                    platform: x.application,
                    page_name: x.pageName,
                    page_url: x.pageUrl,
                    page_username: x.pageSelectorUsername,
                    page_id: x.pageSelectorAccountId,
                    creator: x.user,
                    tasking_status: "In progress...", 
                    date_created_epoch: x.date_created_epoch
                  }
                )  
              } 
            } 
          })  
          temp.sort(function(a, b) {   
            console.log(new Date(b.date_created_epoch))
            return new Date(b.date_created_epoch) - new Date(a.date_created_epoch);
          }); 
          setRows(temp);  
          setLoading(false);
        } catch (error) {
          console.log('GET call failed: ', error);
        }
      } 
      getData();   
    }, [])  
    
    const downloadResult = (pk) => {
      const endpoint = endpoints.URGENT_TASKING + "?taskingId=" + pk; 
      // console.log(endpoint);
      const xhr = new XMLHttpRequest();
      return new Promise((resolve, reject) => {
        xhr.open("GET", endpoint);   
        xhr.setRequestHeader("Access-Control-Allow-Origin", "*"); 
        xhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token,access-control-allow-origin,access-control-allow-methods,access-control-allow-headers,auth-token,Access-Control-Allow-Origin,GET,OPTIONS,Origin,X-Auth-Token,authorizationToken")
        xhr.setRequestHeader("authorizationToken", "hunny-allow-1713316693000");  
        xhr.send(); 
        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {  
            let body = JSON.parse(xhr.response);  
            window.open(body.data.downloadUrl);  
          } else { 
            console.log("Error downloading result:" + pk, xhr.status);  
          }
        }    
      })
    }      
     
    const columns =  [
        {
            field: "id",
            headerName: "Ref. #", 
            minWidth: 100,
            flex: 2,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },        
        {
            field: "platform",
            headerName: "Platform",
            minWidth: 100,
            flex: 1,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "page_name",
            headerName: "Post Name",
            minWidth: 150,
            flex: 3,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "page_url",
            headerName: "Post URL",
            minWidth: 200,
            flex: 5,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "page_username",
            headerName: "Post Username",
            minWidth: 150,
            flex: 1,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "page_id",
            headerName: "Post ID",
            minWidth: 150,
            flex: 1,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "creator",
            headerName: "Creator",
            minWidth: 100,
            flex: 1,
            sortable: true, 
            renderCell: (params) => ( 
              <Typography className="typography-multiline">{params.value}</Typography> 
            )
        },
        {
            field: "tasking_status",
            headerName: "Tasking Status",
            minWidth: 200,
            flex: 3,
            sortable: true, 
            filterable: false, 
            renderCell: (params, row) => ( 
              params.value.includes("spoc-adhoc-bucket") ? <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => {downloadResult(params.value.split("completed/")[1].split(".zip")[0])}}>Download Result</Button> : 
              params.value.includes("progress") ? <Typography className="typography-multiline">{params.value}</Typography>  : 
              <Box sx={{ display: "flex", flexDirection: "row" }}><Typography color="red" className="typography-multiline">{params.value}</Typography></Box>
            )
        },            
      ];   
 
    if (loading) {
      return <div className="loader">
        <CircularProgress color="inherit"/>
      </div> 
    }  
    
    return (  
      <div style={{ height: '100%', width: "300", paddingBottom: "5rem"}}>
        <DataGrid    
            initialState={{ 
                pagination: { paginationModel: { pageSize: 10 } },
            }}
            editMode="row"
            rows={rows} 
            columns={columns}
            pageSizeOptions={[5, 10, 30]}       
            disableSelectionOnClick 
            disableRowSelectionOnClick 
            disableColumnResize 
            disableColumnMenu
            slots={{ toolbar: CustomToolbar }}
            sx={{
                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important", 
                },  
                "&.MuiDataGrid-root .MuiDataGrid-cell": {
                    whiteSpace: "normal !important",
                    wordWrap: "break-word !important", 
                    display: "flex !important",
                    alignItems: "center !important"  
                },
                ".MuiButton-root": {
                    color: "#605958"
                },
                "& .MuiDataGrid-row:hover": {
                    backgroundColor: "rgba(218,218,218,0)", 
                }
            }} 
        />
      </div>    
  );
}  